import api from '@utils/api';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
const RegisteredInStoreCheckoutConfirm = (props) => {
    const { t } = useTranslation();
    const [clickedCta, setClickedCta] = useState(false);
    const sendEmail = () => {
        api.forgotPasswordSendMail(props.email);
        setClickedCta(true);
    };
    return (React.createElement(React.Fragment, null, !clickedCta ? (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-sm-6" },
            React.createElement("p", { dangerouslySetInnerHTML: {
                    __html: t('orderconfirmation.thankyou.sendemail', { 0: props.email }),
                } })),
        React.createElement("div", { className: "col-sm-6" },
            React.createElement("button", { className: " button button--secondary", onClick: () => sendEmail() }, t('login.registeredinstore.sendemail'))))) : (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-sm-6" },
            React.createElement("p", { dangerouslySetInnerHTML: {
                    __html: t('orderconfirmation.thankyou.resendemailtext', { 0: props.email }),
                } })),
        React.createElement("div", { className: "col-sm-6" },
            React.createElement("span", null, t('orderconfirmation.thankyou.resendemail')),
            React.createElement("div", { className: "mt-12" },
                React.createElement("button", { className: "button button--secondary", onClick: () => sendEmail() }, t('login.registeredinstore.resendemail'))))))));
};
export default RegisteredInStoreCheckoutConfirm;
